// Generated from SVG to Code Figma Plugin

export const BaseFillCheckPick3 = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.25 6.46875C3.25 4.8119 4.59315 3.46875 6.25 3.46875H18.25C19.9069 3.46875 21.25 4.8119 21.25 6.46875V18.4688C21.25 20.1256 19.9069 21.4688 18.25 21.4688H6.25C4.59315 21.4688 3.25 20.1256 3.25 18.4688V6.46875Z"
      fill="#84C5FF"
      stroke="#84C5FF"
      strokeWidth="1.5"
    />
    <path
      d="M8.25 12.4688L11.25 15.4688L17.25 9.46875"
      opacity="0.6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);
